import HostedMobileLayout from '../../../layouts/MobileLayout';
import HostedAppPairingScreen from '../shared/AppPairingScreen';
import { type AppPairingPageProps } from '../../../chulak/ChulakSession';

export default function HostedMobileAppPairingPage(props: AppPairingPageProps) {
  return (
    <HostedMobileLayout>
      <HostedAppPairingScreen {...props} />
    </HostedMobileLayout>
  );
}
